import type { components } from '@trackercop/contracts';

type PayloadCategory = components['schemas']['PayloadCategory'];

// Severity rank used to pick the "dominant" category on an edge. PII
// outranks identifier outranks everything else — a reviewer who sees a
// red edge knows the edge contains PII regardless of whatever else is
// on it. Shared between the per-crawl data-sharing map and the
// site-level data-flow recipients view; do not redefine in either.
export const PAYLOAD_CATEGORY_SEVERITY: Record<PayloadCategory, number> = {
  pii: 7,
  identifier: 6,
  'device-fingerprint': 5,
  behavioral: 4,
  advertising: 3,
  product: 2,
  benign: 1,
};

export const PAYLOAD_CATEGORY_EDGE_COLOR: Record<PayloadCategory, string> = {
  pii: '#dc2626',
  identifier: '#ea580c',
  'device-fingerprint': '#d97706',
  behavioral: '#eab308',
  advertising: '#7c3aed',
  product: '#2563eb',
  benign: '#9ca3af',
};

export const SENSITIVE_CATEGORIES: ReadonlySet<PayloadCategory> = new Set<PayloadCategory>([
  'pii',
  'identifier',
  'device-fingerprint',
  'behavioral',
  'advertising',
]);

export function dominantCategoryOf(
  cats: Iterable<PayloadCategory>,
): PayloadCategory {
  let best: PayloadCategory = 'benign';
  let bestRank = -1;
  for (const c of cats) {
    const rank = PAYLOAD_CATEGORY_SEVERITY[c];
    if (rank > bestRank) {
      best = c;
      bestRank = rank;
    }
  }
  return best;
}
